import { render, staticRenderFns } from "./ReviewAPIHarvester.vue?vue&type=template&id=bb19367e&"
import script from "./ReviewAPIHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewAPIHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports